// extracted by mini-css-extract-plugin
export default {"root":"slideThree_root__lFhO1"};